export namespace DotcEnums {
  export enum AssetType {
    NoType = 0,
    ERC20 = 1,
    ERC721 = 2,
    ERC1155 = 3,
  }

  export enum TakingOfferType {
    NoType = 0,
    PartialOffer = 1,
    BlockOffer = 2,
  }

  export enum OfferPricingType {
    NoType = 0,
    FixedPricing = 1,
    DynamicPricing = 2,
  }

  export enum OfferFillType {
    NotTaken = 0,
    Cancelled = 1,
    PartiallyTaken = 2,
    FullyTaken = 3,
  }

  export enum PercentageType {
    NoType = 0,
    Plus = 1,
    Minus = 2,
  }
}
